// extracted by mini-css-extract-plugin
export default {"root":"pMDtHWezXlEFXdL1KfgE","text":"JaoHhwSRVYPUgDu4ejjb","x":"kk165KH97nNcppS1vCiG"};